'use strict'

import VueHtml2pdf from 'vue-html2pdf'

export default Vue => {
  return Vue.use(VueHtml2pdf)
}
